import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const PencilUnderline = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("rect", { x: "2.637", y: "21.23", width: "19", height: "2" }),
    React.createElement("path", { d: "M16.048,0.77L3.717,12.729l-1.354,6.776l6.76-1.352l12.34-11.97L16.048,0.77z M18.613,6.162 L16.77,7.949l-2.586-2.586l1.843-1.787L18.613,6.162z M8.152,16.308l-3.24,0.648l0.646-3.224l7.191-6.976l2.586,2.586L8.152,16.308z" })), 'PencilUnderline');
export default PencilUnderline;
